<template>
  <div>
    <img
      v-if="getAppleVppIcon"
      :src="getAppleVppIcon"
    >
    <Icon
      v-if="!getAppleVppIcon"
      icon="applications"
      :scale="3"
    />
  </div>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import { get } from 'lodash';
import AppleVppIconMixin from 'client/SoftwareApps/mixins/AppleVppIconMixin';

export default {
  name: 'VppAppIcon',

  components: {
    Icon,
  },

  mixins: [
    AppleVppIconMixin,
  ],

  props: {
    iconField: {
      default: 'settings[0].appleVpp.details.artwork.url',
      type: String,
    },
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    getAppleVppIcon() {
      const uglyUrl = get(this.item, this.iconField, '');
      return !uglyUrl ? false : this.configureIconUrl({ uglyUrl, width: '40', height: '40' });
    },
  },
};
</script>
